import { render, staticRenderFns } from "./ModalQuoteAmounts.vue?vue&type=template&id=260b29ab&lang=pug&"
import script from "./ModalQuoteAmounts.vue?vue&type=script&lang=js&"
export * from "./ModalQuoteAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports